<template>
  <v-container>
    <div
      class="display-2 mb-7 mt-5 font-weight-thin"
      color="primary"
    >{{$tc('entities.printer.title',2)}}</div>
    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>

    <btn-a v-if="!noAction" rounded color="primary" @click="editItem" :access="$access.report.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>

    <table-grid
      :noAction="noAction"
      :multiple="multiple"
      :singleSelect="singleSelect"
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
      @input="pagination.page = $event"
      @click="clickTable($event)"
      @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.printer.title',1)"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected,$refs.form.isValid())"
      @delete="deleteItem(itemSelected,true)"
      :loading="loadingDialog"
      :alert="form.alert"
      :accessConfirm="$access.report.edit"
      :accessDelete="$access.report.delete"
    >
      <printer-form v-if="itemSelected" ref="form" v-model="itemSelected" />
    </dialog-d>
  </v-container>
</template>

<script>
import printerService from "@/services/printerService";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
import printerForm from "../components/forms/printers/printerForm";
export default {
  props: {},
  mixins: [pageListMixing],
  components: { printerForm },

  data() {
    return {
      entityService: printerService,
      apiController: "printer",
      searchFields: ["code", "description"],
      headers: [
        {
          text: this.$t("entities.printer.props.code"),
          align: "left",
          sortable: false,
          value: "code"
        },
        {
          text: this.$t("entities.printer.props.description"),
          align: "left",
          sortable: false,
          value: "description"
        },

        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right"
        }
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.printer.edit, this.$access.printer.show]
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.printer.delete
        }
      ]
    };
  },
  methods: {
    save() {
      console.log(this.$refs.form);
      this.saveItem(this.itemSelected, true);
    },
    async getModelDefault() {
      return {
        code: "",
        description: "",
        path: "",
        printAgentPath: ""
      };
    }
  },
  async mounted() {
    await this.getItems();
  }
};
</script>